import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { getResetByTag, zIndex } from './../../../styles';
var defaultStyles = /*#__PURE__*/css("display:block;white-space:nowrap;width:100%;z-index:", zIndex.zIndex_0, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
var resetStyles = getResetByTag('span');
var StyledFormFieldLabel = /*#__PURE__*/_styled('span', process.env.NODE_ENV === "production" ? {
  target: "e1jav9zx0"
} : {
  target: "e1jav9zx0",
  label: "StyledFormFieldLabel"
})(resetStyles, defaultStyles);
export default StyledFormFieldLabel;